export enum LoyaltyPointAPISortBy {
  CREATED_AT = 'created_at',
  EXPIRED_AT = 'expired_at',
}
